import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axiosPost from '../helpers/axios-helper';

export default function ProtectedRoute({ children }) {
    const [cookies, , removeCookie] = useCookies(['auth_token']);
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = cookies.auth_token;
        
        if (!token) {
            setIsAuthenticated(false);
            setIsLoading(false);
            return;
        }

        // Validate token with backend
        axiosPost(
            'auth/validate-token',
            { 'Content-Type': 'application/json' },
            { token },
            (resp) => {
                if (resp?.success) {
                    // Update account info if returned
                    if (resp?.data?.account) {
                        localStorage.setItem('auth_account', JSON.stringify(resp.data.account));
                    }
                    setIsAuthenticated(true);
                } else {
                    // Token invalid, clear cookie and storage
                    removeCookie('auth_token', { path: '/' });
                    localStorage.removeItem('auth_account');
                    setIsAuthenticated(false);
                }
                setIsLoading(false);
            },
            (err) => {
                console.error('Token validation error:', err);
                removeCookie('auth_token', { path: '/' });
                localStorage.removeItem('auth_account');
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        );
    }, [cookies.auth_token, removeCookie]);

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                background: '#FAF9F7',
                fontSize: '16px',
                color: '#666'
            }}>
                Loading...
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/dashboard/login" replace />;
    }

    return children;
}
